<template>
  <modal
    title="Assign Face to Person"
    ref="modal"
  >
    <div
      v-if="face"
      class="row q-col-gutter-md"
    >
      <div class="col-12 col-sm-4 flex flex-center column">
        <q-img
          v-if="face.imageUrl"
          :src="face.imageUrl"
          :ratio="1"
          fit="cover"
          class="rounded-borders"
          style="width: 140px; height: 140px;"
        />
        <q-icon
          v-else
          name="fa fa-user-circle"
          size="120px"
          color="grey-5"
        />
        <div class="text-caption text-center q-mt-sm text-grey-6">
          {{ Math.round(face.confidence) }}% confidence
        </div>
      </div>

      <div class="col-12 col-sm-8">
        <div class="text-subtitle1 q-mb-sm">Select a Person</div>
        <PersonSelect
          ref="personSelect"
          :client-id="clientId"
          :model-value="selectedPersonId"
          @update:model-value="selectedPersonId = $event"
          @created="onPersonCreated"
        />
      </div>
    </div>

    <template v-slot:actions>
      <q-btn
        flat
        no-caps
        icon="fa fa-plus"
        label="New Person"
        color="primary"
        @click="toggleCreate()"
      />
      <q-space />
      <q-btn
        flat
        label="Cancel"
        @click="hide()"
      />
      <AsyncBtn
        label="Assign"
        color="primary"
        :task="task"
        :disabled="!selectedPersonId"
        @click="assign"
      />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin, ModalMixin } from '@/mixins';
import { Face } from '@/analysis/types';
import { Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import PersonSelect from '../person/PersonSelect.vue';
import { assign } from './face';

interface Data {
  face: Face | null;
  selectedPersonId: number | null;
}

export default defineComponent({
  emits: ['assigned'],
  mixins: [HasTaskMixin, ModalMixin],
  components: {
    Modal,
    AsyncBtn,
    PersonSelect,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      face: null,
      selectedPersonId: null,
    };
  },
  methods: {
    toggleCreate() {
      (this.$refs.personSelect as any).toggleCreate();
    },
    onPersonCreated(personId: number) {
      this.selectedPersonId = personId;
      this.assign();
    },
    open(face: Face) {
      this.face = face;
      this.selectedPersonId = null;
      (this.$refs.modal as ModalElement).show();
    },
    assign() {
      if (!this.face || !this.selectedPersonId) return;

      const promise = assign(this.face.id, this.selectedPersonId);
      promise.then((face: Face) => {
        this.$emit('assigned', face);
        (this.$refs.modal as ModalElement).hide();
        notify('Face assigned to person.');
      }).catch(() => {
        notify('Failed to assign face.', 'negative');
      });
      this.task = promise;
    },
  },
});
</script>
